import { faXmark } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Modal } from "react-bootstrap"

interface Props {
    showModal: boolean
    onHide: () => void
}

const InvalidStudentLogInModal = ({ showModal, onHide } : Props) => {
    const navigateSelectClass = () => {
      window.location.href = "/student/select-class/"
    }

  return (
    <Modal show={showModal} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title className="w-100"><FontAwesomeIcon icon={faXmark} /> Incomplete Log In</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>You are not completely logged in. Please complete the log in by selecting both class and student.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={navigateSelectClass}>
          Complete Log In
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default InvalidStudentLogInModal
